export default {
	couponList: '/coupons/list', //分页列表
	addCoupon: '/coupons', //新建
	functionList: '/admin/function_items/all_enable_list', //只查已启用的列表
	customerList: '/coupons/customer/param_name/list', //客户名称列表
	editCoupon: '/coupons/{id}', //编辑
	getCoupon: '/coupons/{id}', //详情
	setNullify: '/coupons/status/{id}', //作废
};
